<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .single-choice-mapping-row {
    display: grid;
    grid-template-columns:
      utils.in_rem(200px)
      utils.in_rem(59px)
      auto
      utils.in_rem(59px)
      auto;
    align-items: center;

    .field-name {
      @include mixins.body2();
    }
    .required {
      @include colors.color(systemError_100);
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";

  import { integrationStore } from "../../../stores";

  export let field = {};
  export let syncAs;

  $: key = field.type === "list" ? `${field.key}[]` : field.key;

  $: targetOptions = [
    { key: "sw__none", label: "None" },
    ...$integrationStore.getFieldOptions(syncAs),
  ];

  $: labels = targetOptions.map((opt) => opt.label);

  const isLabelRepeated = (label) =>
    labels.filter((l) => l === label).length > 1;

  $: items = targetOptions.map((opt) => ({
    id: opt.key,
    label: opt.label,
    description: isLabelRepeated(opt.label) ? opt.key : "",
    required: opt.required,
  }));

  $: selected = $integrationStore.getFieldValue(key, syncAs) || "";

  // Watch for changes to selected and update the store if needed
  $: if (selected !== ($integrationStore.getFieldValue(key, syncAs) || "")) {
    $integrationStore.setFieldValue(key, selected, syncAs);
  }
</script>

<div class="single-choice-mapping-row">
  <div class="field-name">{field.title}</div>
  <Icon class="fas fa-arrow-right"></Icon>
  <div class="input-field">
    <SingleSelectDropdown
      style="width:240px"
      size="large"
      {items}
      bind:selected
      placeholder="Select one"
      showFilter={items.length > 10}
      showDescription={true}
      restrictHeight={true}
    />
  </div>
</div>
